import React, { FC, useRef, useState } from 'react';
import DefLabel from 'src/components/atoms/label/LabelContnet';
import CheckBox from 'src/components/atoms/CheckBox';
import InputBox from 'src/components/atoms/input/InputBox';
import InputDateBox from 'src/components/atoms/input/InputDateBox';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import { familyDataStore } from 'src/store/familyInfo';
import FamilySet from 'src/components/organisms/template/StepA/MyFamilyInfo/FamilySet';
import FamilyCard from 'src/components/organisms/template/StepA/MyFamilyInfo/FamilyCard';
import { contentModalViewStore } from 'src/store/modal';

import './style.scss';

interface Props {}

const FamilyInfo: FC<Props> = () => {
  const familyInfoDataStateResult = familyDataStore((state: any) => state.result);
  const familyInfoData = familyInfoDataStateResult.data || [];

  const setContentModalState = contentModalViewStore((state: any) => state.set);

  const addEvt = () => {
    setContentModalState({
      active: '_active',
      title: '부양가족 추가',
      content: <FamilySet viewType="insert" />,
      styleDef: { width: '950px' },
    });
  };
  const checkClickEvt = (e: React.MouseEvent, type: string) => {};

  return (
    <div className="_step_a_family_n_info">
      <div className="_box_set">
        {familyInfoData.map((item: any, idx: number) => {
          const residentNumFr = item.residentNumberFr || '';
          const residentNumBe = item.residentNumberBe || '';
          const residentNum = residentNumFr + '-' + residentNumBe;
          return (
            <div className="_box_div" key={idx}>
              <FamilyCard familyData={item} />
            </div>
          );
        })}
        <div className="_box_div">
          <FamilyCard familyData={{}} type="add" addEvent={addEvt} />
        </div>
      </div>
      {/* <div className="_btn_div">
        <DefaultButton
          text="부양가족 추가"
          clickEvent={e => addEvt()}
          icon=""
          status=""
          type="type2"
          styleDef={{
            width: '250px',
          }}
        />
      </div> */}
    </div>
  );
};

export default FamilyInfo;
